/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TokenService } from '../token/token.service';
import { TokenStateActive } from './token-state.interface';
import { BasicTokenState } from '../basic-token-state/basic-token-state.service';

const initialState: TokenStateActive[] = [];
// file unit test nya mana
// pake yg dari shared
@Injectable({
  providedIn: 'root'
})
export class TokenStateService extends BasicTokenState<TokenStateActive[]> {
  activeTokens$: Observable<TokenStateActive[] | null> = this.select(state => {
    const arr:any[] = [];
    Object.keys(state).forEach((msisdn:any) => arr.push(state[msisdn]));

    return arr;
  });

  selectedToken$: Observable<TokenStateActive | null> = this.select((state) => {
    return state ? state[0] : null;
  });

  constructor(
    private tokenService: TokenService
    // private storeService: StoreService
  ) {
    super(initialState);

    const savedData = this.tokenService.getData('saved-token');
    if (savedData) {
      this.setState(savedData);
    }
  }

  storeToken(token: TokenStateActive) {
    const arr:any[] = [];
    if (this.state) Object.keys(this.state).forEach((msisdn:any) => arr.push(this.state![msisdn]));

    const tokenExistIndex = arr.findIndex((a) => a.cust_msisdn === token.cust_msisdn);
    if (tokenExistIndex !== -1) arr.splice(tokenExistIndex, 1);

    const tokenData = [token, ...arr];

    this.tokenService.storeData('saved-token', tokenData);
    return this.setState(tokenData);
  }

  removeToken(msisdn:number) {
    const arr:any[] = [];
    Object.keys(this.state!).forEach((msisdn:any) => arr.push(this.state![msisdn]));

    const removedToken = arr.filter((token) => {
      return token.cust_msisdn !== msisdn;
    });

    this.tokenService.storeData('saved-token', removedToken);
    return this.setState(removedToken);
  }

  clearToken() {
    this.tokenService.removeData('saved-token');
    this.setState([]);

    this.selectedToken$ = this.select(() => {
      return null;
    });
  }

  removeSavedToken() {
    this.tokenService.removeData('saved-token');
    this.removeState();

    this.selectedToken$ = this.select(() => null);
  }
}
